export const encodeProductId = (shopId: string, productRef: string):string => {
    return btoa(`${shopId}-${productRef}`);
}
export const decodeProductId = (encodedId: string): { shopId: string, productRef: string } => {
    const decoded = atob(encodedId);
    const [shopId, productRef] = decoded.split('-');
    return { shopId, productRef };
};